import React, { useState } from "react";
import { utilSignInWithGoogle } from "../../util/UtilsFirebase";
import { sendSignInLinkToEmail } from "firebase/auth";
import { projectAuth } from "../../firebase/config";

const Register = () => {
  const [email, setEmail] = useState("");
  const actionCodeSettings = {
    // URL you want to redirect back to. The domain (www.example.com) for this
    // URL must be in the authorized domains list in the Firebase Console.
    url: "https://rapdis.com/login",
    // This must be true.
    handleCodeInApp: true,
    // iOS: {
    //   bundleId: "rapdis-app-deliver",
    // },
    // android: {
    //   packageName: "com.venonline.rapdis",
    //   installApp: true,
    //   minimumVersion: "12",
    // },
    // // The domain must be configured in Firebase Hosting and owned by the project.
    // linkDomain: "rapdis.com",
  };

  const handleRegister = async () => {
    try {
      sendSignInLinkToEmail(projectAuth, email, actionCodeSettings)
        .then(() => {
          window.localStorage.setItem("emailForSignIn", email);
          alert(
            "Se a enviado un correo para verificar tu email.\n \n Nota: revisa que tu correo electronico este correcto,\n y recuerda revisar tu bandeja de spam."
          );
        })
        .catch((error) => {
          const errorCode = error.code;
          const errorMessage = error.message;
          alert(errorMessage + "(" + errorCode + ")");
        });
    } catch (error) {
      alert(error);
      console.error(error);
    }
  };

  const handleSignInWithGoogle = async () => {
    try {
      const user = await utilSignInWithGoogle();
      console.log(user);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className="container margin-login">
      <div className="row justify-content-center">
        <div className="col-lg-4 col-md-6 col-sm-8">
          <h2 className="text-center">Registra tu correo</h2>
          <form className="container-auth" onSubmit={(e) => e.preventDefault()}>
            <div className="form-group">
              <label htmlFor="email"></label>
              <input
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div className="container-buttons">
              <button type="button" onClick={handleRegister}>
                Registrar
              </button>
            </div>
            <div className="center">- O -</div>
            <div className="container-buttons2">
              <button type="button" onClick={handleSignInWithGoogle}>
                Continuar con Google
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Register;
